import { render, staticRenderFns } from "./UserGuide.vue?vue&type=template&id=589a30fb"
import script from "./UserGuide.vue?vue&type=script&lang=js"
export * from "./UserGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports